import {createApp} from 'vue';
import {SetupCalendar} from 'v-calendar';
import RentalModal from "./Components/RentalModal";

if(document.getElementById('rental-app')) {
    createApp(RentalModal)
        .use(SetupCalendar)
        .mount('#rental-app');
}